<template lang="pug">
.match-bet-area-type
  .match-bet-area-type-title {{ betType == 'ml' ? $tc("m.BT_MLF", 2) : $tc("m.BT_MLH", 2) }}
  .match-odd-area
    .match-odd-area-oddtype
      p.mb-0 {{ $t("m.ODD_Home") }}
      p.mb-0 {{ $t("m.ODD_Away") }}
    template(v-for="(dn, i) in details['tn']")
      .match-odd-area-group(v-if="i == 0")
        template(v-if="details[betType] && details[betType][i] && details[betType][i][5] != 0 && details[betType][i][7] != 0 && details[betType][i][5] != '' && details[betType][i][7] != ''")
          OddsItem(:odds="details[betType][i]" idx=5 :typ="oddsType" dataType="2" :mode="betType" :count="i" :details="details" homeAway="1")
        template(v-else)
          OddsDisabled
        template(v-if="details[betType] && details[betType][i] && details[betType][i][5] != 0 && details[betType][i][7] != 0 && details[betType][i][5] != '' && details[betType][i][7] != ''")
          OddsItem(:odds="details[betType][i]" idx=7 :typ="oddsType" dataType="2" :mode="betType" :count="i" :details="details" homeAway="2")
        template(v-else)
          OddsDisabled
</template>

<script>
import OddsItem from "@/components/mobile/main/xitem/oddsItem";
import OddsDisabled from "@/components/mobile/main/xitem/oddsDisabled";

export default {
  components: {
    OddsItem,
    OddsDisabled
  },
  props: {
    details: {
      type: Object
    },
    oddsType: {
      type: String
    },
    i: {
      type: [String, Number]
    },
    betType: {
      type: String
    },
    homeAway: {
      type: String
    },
  }
};
</script>